// Register toast components globally
import BookmarkImport from '@/toasts/BookmarkImport.vue'

export function setupToastComponents(app) {
  console.log('[ToastComponents] Registering toast components globally')
  console.log('[ToastComponents] BookmarkImport component:', BookmarkImport)
  
  // Register all toast components here
  app.component('BookmarkImport', BookmarkImport)
  
  // Verify registration
  const registered = app.component('BookmarkImport')
  console.log('[ToastComponents] BookmarkImport registered:', !!registered)
  console.log('[ToastComponents] Toast components registered successfully')
}